var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      class: ["overflow-hidden statistics-card", "statistics-card-" + _vm.type],
    },
    [
      _c("template", { slot: "no-body" }, [
        _c("div", { staticClass: "p-4" }, [
          _c("div", { staticClass: "flex items-center justify-between" }, [
            _c("div", { staticClass: "flex-1 min-w-0" }, [
              _c(
                "p",
                {
                  staticClass:
                    "text-xs font-medium text-gray-500 uppercase tracking-wide mb-1",
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
              _c(
                "h2",
                {
                  class: [
                    _vm.valueSize === "large" ? "text-2xl" : "text-xl",
                    "font-bold text-gray-900 leading-tight",
                  ],
                },
                [_vm._v(" " + _vm._s(_vm.formattedValue) + " ")]
              ),
              _c("p", { staticClass: "text-xs text-gray-500 mt-1" }, [
                _vm._v(" " + _vm._s(_vm.description) + " "),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "flex-shrink-0 ml-3 p-2 rounded-full",
                style: _vm.iconBackgroundStyle,
              },
              [
                _c("feather-icon", {
                  class: _vm.iconClass,
                  attrs: { icon: _vm.icon, size: "18" },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }